// คอลัมน์ "โปรแกรมหลัก / เฉพาะโปรแกรมนี้ / ระดับความสำคัญ / วิธีคิดแต้ม / ขอบเขต" ถูกตัดออก
// เพราะระบบสะสมแต้มรองรับโปรแกรมเดียว ค่าทั้งห้าจึงคงที่ตลอด
// (base=จริง, exclusive=ไม่, priority=0, earn_basis=by_spend, earn_scope=all_eligible)
// โชว์ "แต้มต่อบาท" แทน — เป็นตัวเดียวที่เปลี่ยนได้และเป็นตัวที่ computeLots() ใช้จริง
// ดูเหตุผลเต็มที่ LoyaltyProgram\CreateMiddleware
export default (t) => [
  {
    text: t('Code'),
    value: 'code',
    sortable: true,
    width: 130,
    togglable: true
  },
  {
    text: t('Name'),
    value: 'name',
    sortable: true,
    width: 200,
    togglable: true
  },
  {
    text: t('Points per Baht'),
    value: 'point_per_baht',
    sortable: false,
    width: 130,
    togglable: true
  },
  {
    text: t('Expiry'),
    value: 'expiry_mode',
    sortable: false,
    width: 130,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 100
  },
];
